/**
 * useActiveSpeaker — thin wrapper around ActiveSpeakerContext.
 *
 * Throws if called outside ActiveSpeakerProvider.
 * All persona components use this hook instead of useTTS() directly.
 *
 * Story v19-1-2: TTS Coordinator — Fix Dual Voice Bug
 */

import { useContext } from 'react';
import { ActiveSpeakerContext } from '../contexts/ActiveSpeakerContext';
import type { ActiveSpeakerState } from '../contexts/ActiveSpeakerContext';

export type { ActiveSpeakerState };

export function useActiveSpeaker(): ActiveSpeakerState {
  const ctx = useContext(ActiveSpeakerContext);
  if (!ctx) {
    throw new Error('useActiveSpeaker must be used within an ActiveSpeakerProvider');
  }
  return ctx;
}
